//模拟数据

let cardhobby={
  times:[
    {value: '1',label: '7 Days'},
    {value: '2',label: '1 month'},
  ],
  sales: [
    {value: '1',label: 'Sales volume'},
    {value: '2',label: 'sales'}
  ],
}
export default{
  cardhobby
}


// WEBPACK FOOTER //
// ./src/api/enum.js